export default "__VITE_ASSET__DYQT7coT__"